import React, { Component } from 'react';
import BasePage from './BasePage';
import Session from '../services/session'
import Banner from '../partials/Banner';

import BreadCrumbs from '../partials/BreadCrumbs';

class Visa extends Component {

    constructor(props) {
        super(props);
        
    }
    

    render() {

        // <Banner images={Session.getBannerPictures('visa')}
        //     title={'Visa'}
        //     text={'Visa'}
        //     />

        return (
                <BasePage data={this.props.data}>
                    <BreadCrumbs fullpath={window.location.pathname} name={""} />
                    <div>Visa</div>
                </BasePage>
        );
    }
}

export default Visa;